import { render, staticRenderFns } from "./CourseGroupsPage.vue?vue&type=template&id=59a197df&scoped=true"
import script from "./CourseGroupsPage.vue?vue&type=script&lang=js"
export * from "./CourseGroupsPage.vue?vue&type=script&lang=js"
import style0 from "./CourseGroupsPage.vue?vue&type=style&index=0&id=59a197df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a197df",
  null
  
)

export default component.exports